/* DegenDalt drop lock — time-based, client-side, cache-immune.
   --------------------------------------------------------------------------
   Single source of truth = the CLIENT clock vs window.degenDrop.time.
   • Cards / feature tiles / quick-views render BOTH the locked and the real
     markup; the `.degen-predrop` class on <html> (set in the head, removed here
     at the drop moment) decides which shows — pure CSS, no reload.
   • The product page's Add-to-Cart is owned by Dawn, so we disable/relabel it
     directly while pre-drop and restore it in place the instant the drop hits.
   Nothing depends on server render time or on inventory, so it fires at the
   drop datetime automatically with no re-publish. */
(function () {
  var cfg = window.degenDrop || {};
  var FALLBACK = '2026-07-24T19:00:00-04:00';
  var target = new Date(cfg.time || FALLBACK).getTime();
  if (isNaN(target)) target = new Date(FALLBACK).getTime();
  if (isNaN(target)) return;

  var html = document.documentElement;
  var unlockLabel = cfg.unlockLabel || 'Available soon';
  var lockThisProduct = window.degenDropProductLocked === true;

  function preDrop() { return Date.now() < target; }

  function syncClass() {
    if (preDrop()) html.classList.add('degen-predrop');
    else html.classList.remove('degen-predrop');
  }

  /* ---- Product page Add-to-Cart (Dawn-owned button) ---- */
  function buyButtons() {
    return document.querySelectorAll(
      'product-form form[action*="/cart/add"] [name="add"],' +
      'form[action*="/cart/add"] button[type="submit"]'
    );
  }
  function lockPdp() {
    if (!lockThisProduct) return;
    buyButtons().forEach(function (btn) {
      var span = btn.querySelector('span:not(.visually-hidden)') || btn;
      if (!btn.dataset.degenOrig) btn.dataset.degenOrig = span.textContent;
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.dataset.degenLocked = '1';
      if (span.textContent.trim() !== unlockLabel) span.textContent = unlockLabel;
    });
    var item = document.querySelector('.product__media-wrapper .product__media-item')
      || document.querySelector('.product__media-wrapper');
    if (item && cfg.badge && !document.querySelector('.degen-pdp-badge')) {
      var b = document.createElement('span');
      b.className = 'degen-tag degen-tag--drop degen-pdp-badge';
      b.textContent = cfg.badge;
      if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
      item.appendChild(b);
    }
  }
  function unlockPdp() {
    buyButtons().forEach(function (btn) {
      if (!btn.dataset.degenLocked) return;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.degenLocked;
      var span = btn.querySelector('span:not(.visually-hidden)') || btn;
      if (btn.dataset.degenOrig) span.textContent = btn.dataset.degenOrig;
    });
    var badge = document.querySelector('.degen-pdp-badge');
    if (badge) badge.remove();
  }

  function blockSubmit(e) {
    if (!lockThisProduct || !preDrop()) return;
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (form) {
      e.preventDefault();
      e.stopPropagation();
      if (window.degenToast) window.degenToast(unlockLabel);
    }
  }
  document.addEventListener('submit', blockSubmit, true);

  function render() {
    syncClass();
    if (preDrop()) lockPdp();
    else unlockPdp();
  }

  function start() {
    render();
    if (preDrop()) {
      // Re-assert over Dawn re-rendering the buy button on variant change.
      var iv = setInterval(function () {
        if (preDrop()) {
          lockPdp();
        } else {
          clearInterval(iv);
          render();
        }
      }, 1000);
      // Fire exactly at the drop — live unlock, no reload.
      setTimeout(function () {
        clearInterval(iv);
        render();
      }, Math.max(0, target - Date.now()) + 200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
